import { generateTumbnail, generateStaticPreview } from 'utils/generatePreview'
import { IMaterial } from 'constants/types/webinar.types'
import { MaterialTypes, Pathname, UTMCampaignWebinarType } from 'constants/data'
import { AnalyticWebinarPlace } from 'constants/analytic-data'
import { URL } from 'constants/SEO'

const formatWebinarSEO = (webinar: IMaterial, path: string) => {
  const { id, seoTitle, seoDescription, videoLink, name, previewName, linkTranslation } = webinar

  return {
    TITLE: seoTitle || name,
    DESCRIPTION: seoDescription || '',
    LINK: linkTranslation
      ? `${URL + '/' + Pathname.WEBINAR + '/' + linkTranslation}`
      : `${URL + path}`,
    IMG: previewName
      ? generateStaticPreview(URL, previewName, MaterialTypes.WEBINAR)
      : generateTumbnail(videoLink),
    type: UTMCampaignWebinarType,
    id: id,
    place: AnalyticWebinarPlace[webinar?.StatusId],
  }
}

export { formatWebinarSEO }
